import React from 'react'
import PropTypes from 'prop-types'
import * as Styled from './ArItemsWithDescription.styled'
import ArSwiper from 'src/components/ArSwiper/ArSwiper'
import deviceInfoProvider from 'src/utils/deviceInfoProvider'
import { Link } from 'gatsby'

class ArItemsWithDescription extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    cta: PropTypes.shape({
      url: PropTypes.string,
      title: PropTypes.string,
    }),
    items: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      image: PropTypes.string,
    })),
  }

  render () {
    const { title, description, cta, items, device } = this.props
    const renderSwiper = device.isMobile
    const Component = renderSwiper ? ArSwiper : 'div'

    return (
      <Styled.Wrapper>
        <Styled.Container>
          <Styled.Text>
            <Link to={cta.url}>
              <Styled.Title>{title}</Styled.Title>
              <Styled.Description dangerouslySetInnerHTML={{ __html: description }}/>
              <Styled.CTA onClick={() => {}} variant="white" label={cta.title}/>
            </Link>
          </Styled.Text>

          <Styled.Items>
            <Component>
              {items.map((item, index) =>
                <Styled.ItemWrapper key={index}>
                  <Styled.Item to={item.link}>
                    <Styled.ItemImage src={item.image} scAspectRatio={1}/>
                    <Styled.ItemTitle>{item.title}</Styled.ItemTitle>
                    <Styled.ItemLink>Learn more</Styled.ItemLink>
                  </Styled.Item>
                </Styled.ItemWrapper>
              )}
            </Component>
          </Styled.Items>
        </Styled.Container>
      </Styled.Wrapper>
    )
  }
}

export default deviceInfoProvider(ArItemsWithDescription)
